import React from "react";
import "./CommonFooter.css";
import { FaWhatsapp, FaEnvelope, FaFacebookF, FaInstagram, FaYoutube, FaAndroid, FaApple } from "react-icons/fa6";
import { Link } from "react-router-dom";
import WhatsAppFloat from "./WhatsAppFloat";
import { imagePath } from "../../../constants/imagePath";
import { useSelector } from "react-redux";

const CommonFooter = ({
  contact = {
    phones: ["+91 9016501095"],
    email: "codeinfoway@gmail.com"
  },
  address = `407, Gravity retail, M G Road, Ahmedabad-12345`,
  productInfo = null,

}) => {
  const { categories } = useSelector((state) => state.categoryState);
  return (
    <footer className="footer">
      <div className="footer__features">
        <div className="footer__feature-item">
          <div className="footer__feature-icon">
            <img src={imagePath.lowPrice} alt="Low Prices" />
          </div>
          <h3 className="footer__feature-text">Low Prices</h3>
        </div>
        <div className="footer__feature-item">
          <div className="footer__feature-icon">
            <img src={imagePath.fastSupport} alt="Fast Support" />
          </div>
          <h3 className="footer__feature-text">Fast Support</h3>
        </div>
        <div className="footer__feature-item">
          <div className="footer__feature-icon">
            <img src={imagePath.quality} alt="100% Quality" />
          </div>
          <h3 className="footer__feature-text">100% Quality</h3>
        </div>
        <div className="footer__feature-item">
          <div className="footer__feature-icon">
            <img src={imagePath.return} alt="Easy Return" />
          </div>
          <h3 className="footer__feature-text">Easy Return</h3>
        </div>
      </div>

      {/* Category Links Section */}
      <div className="footer__categories">
        <div className="footer__category-links">
          {categories?.map((category, index) => (
            <React.Fragment key={category._id}>
              <Link 
                to={`/category?category_id=${category._id}`} 
                state={{ category: category }}
                className="footer__category-link"
              >
                {category.name}
              </Link>
              {index < categories.length - 1 && (
                <span className="footer__category-separator">|</span>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>

      <div className="footer__grid">

        <section className="footer__section">
          <h3 className="footer__title">CONTACT DETAIL</h3>
          <div className="footer__subtitle">FOR INQUIRY</div>
          <ul className="footer__list">
            {contact.phones?.map((ph, idx) => (
              <li key={`${ph}-${idx}`} className="footer__row">
                <FaWhatsapp className="footer__icon" />
                <a
                  className="footer__link"
                  href={`https://wa.me/${ph.replace(/[^\d+]/g, "")}?text=${encodeURIComponent("Hi! I'm interested in your products. Can you help me with more information?")}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {ph}
                </a>
              </li>
            ))}
            {contact.email && (
              <li className="footer__row">
                <FaEnvelope className="footer__icon" />
                <a className="footer__link" href={`mailto:${contact.email}`}>{contact.email}</a>
              </li>
            )}
          </ul>
        </section>

        <section className="footer__section">
          <h3 className="footer__title">QUICK LINKS</h3>
          <ul className="footer__list">
            <li className="footer__row">
              <Link to="/privacy-policy" className="footer__link" target="_blank" rel="noopener noreferrer">Privacy Policy</Link>
            </li>
            <li className="footer__row">
              <Link to="/terms-and-conditions" className="footer__link" target="_blank" rel="noopener noreferrer">Terms & Conditions</Link>
            </li>
            <li className="footer__row">
              <Link to="/return-policy" className="footer__link" target="_blank" rel="noopener noreferrer">Return Policy</Link>
            </li>
            <li className="footer__row">
              <Link to="/shipping-policy" className="footer__link" target="_blank" rel="noopener noreferrer">Shipping Policy</Link>
            </li>
            <li className="footer__row">
              <Link to="/exchange-policy" className="footer__link" target="_blank" rel="noopener noreferrer">Exchange Policy</Link>
            </li>
            <li className="footer__row">
              <Link to="/contact-us" className="footer__link" target="_blank" rel="noopener noreferrer">Contact Us</Link>
            </li>
          </ul>
        </section>

        <section className="footer__section">
          <h3 className="footer__title">GET IN TOUCH</h3>
          <div className="footer__row footer__address">
            <p className="footer__text" style={{ whiteSpace: "pre-line" }}>{address}</p>
          </div>
          <div>
            <h3 className="footer__title">SOCIALIZE WITH US</h3>
            <div className="contact-us__social-icons">
              <a href="https://www.facebook.com/people/Codeinfoway/61570993910963/" target="_blank" rel="noopener noreferrer" className="contact-us__social-icon">
                <FaFacebookF />
              </a>
              <a href="#" rel="noopener noreferrer" className="contact-us__social-icon">
                <FaInstagram />
              </a>
              {/* <a href="https://www.youtube.com/channel/UCdpm8DEMicNuL-ssjQfqEPA" target="_blank" rel="noopener noreferrer" className="contact-us__social-icon">
                <FaYoutube />
              </a> */}
            </div>
          </div>
        </section>

        {/* <section className="footer__section">
          <h3 className="footer__title">DOWNLOAD OUR APP</h3>
          <div className="footer__app-download">
            <a 
              href="https://apps.apple.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="footer__app-store-button footer__app-store-button--ios"
            >
              <div className="footer__app-store-logo">
                <FaApple />
              </div>
              <div className="footer__app-store-text">
                <span className="footer__app-store-small">Download on the</span>
                <span className="footer__app-store-large">App Store</span>
              </div>
            </a>
            <a 
              href="https://play.google.com/store" 
              target="_blank" 
              rel="noopener noreferrer"
              className="footer__app-store-button footer__app-store-button--android"
            >
              <div className="footer__app-store-logo">
                <FaAndroid />
              </div>
              <div className="footer__app-store-text">
                <span className="footer__app-store-small">ANDROID APP ON</span>
                <span className="footer__app-store-large">
                  <span>Google </span>
                  <span className="footer__app-store-bold">play</span>
                </span>
              </div>
            </a>
          </div>
        </section> */}
      </div>
      <div className="footer__bottom">
        <span>© {new Date().getFullYear()} Codeinfoway</span>
      </div>
      <WhatsAppFloat productInfo={productInfo} />
    </footer>
  );
};

export default CommonFooter; 